import React, { Component } from 'react';
import { Combobox } from 'evergreen-ui';
import Request from '../../../util/Api';

class CityAutocomplete extends Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);

        this.state = {
            options: []
        }
    }

    async handleChange(event) {
        let value = event.target.value;

        if(!value) {
            return;
        }

        let results = await Request.get('/public/city-autocomplete', null, {
            name: value,
            county: this.props.county || null
        });

        this.setState({
            options: results.data.cities.map(result => ({id: result.id, label:  this.props.county ? result.name : result.county.name + ' > ' + result.name }))
        })
    }

    render() {
        let opts = this.state.options;

        if(this.props.value) {
            opts = [this.props.value, ...this.state.options.filter(option => option.id === this.props.value.id ? false: true)];
        }

        return (
            <>
                <Combobox
                    width="100%"
                    selectedItem={this.props.value}
                    items={opts}
                    onKeyUp={this.handleChange}
                    onChange={(value) => {
                        if(!value) {
                            return;
                        }

                        this.props.onChange(value);
                    }}
                    placeholder="Oras"
                    itemToString={item => item ? item.label ? item.label : item.name ? item.name : "" : ""}
                    />
            </>
        );
    }

}

export default CityAutocomplete;